(ns io.daskul.webapp.widgets.layout.slide-over
  "Slide-over panel component for forms and detail views.

   Uses Mantine Drawer anchored to the right side. Provides consistent
   header with title and close button, scrollable content area."
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.ui.icons :as icons]))

(defui slide-over
  "Reusable slide-over panel component.

   Props:
     :open? - Boolean, controls visibility
     :on-close - Function called when panel should close
     :title - String, panel header title
     :size - Optional size (default 'lg', options: xs, sm, md, lg, xl, or number)

   Children are rendered in scrollable content area.

   Usage:
     ($ slide-over {:open? panel-open?
                    :on-close #(set-panel-open! false)
                    :title \"Edit Section\"}
       ($ my-form-component ...))"
  [{:keys [open? on-close title size children]
    :or {size "lg"}}]
  ($ ui/drawer
    {:opened open?
     :onClose on-close
     :position "right"
     :size size
     :title title
     :closeButtonProps #js {:icon ($ icons/icon-x {:size 20})}}
    children))
